import React from 'react';
import { configData } from "../config";
import './classes/QuickLinks.css';

// Who gets the live site's staff blocks in a page's right column (Quick Links and Applicant & Agent
// Search): administrators, SA admins, salespeople and sales directors
export const hasStaffBlocks = (roles) =>
    Array.isArray(roles) &&
    [configData.ROLE_ADMINISTRATOR, configData.ROLE_SAADMIN, configData.ROLE_SALES_PEOPLE, configData.ROLE_SALES_DIRECTOR]
        .some((role) => roles.includes(role));

// The live site's "Quick Links" block in the right column, for signed-in staff: under the form on
// the pages with the general quick form (degree pages, course pages outside /courses, conference
// pages), and at the top on the Courses and Conferences pages and the course pages under /courses.
// As on the live site (smww_operations()), administrators get Dashboard Home, Manage My Profile,
// My Account and People, and salespeople and sales directors Dashboard Home. SA admins get the
// staff sidebar's SA admin links (SalespersonSidebar), which live does not show on these pages.
// The links go to this site's pages, as the staff sidebar's do.
const QuickLinks = ({ roles }) => {
    if (!hasStaffBlocks(roles)) return null;
    const isAdministrator = roles.includes(configData.ROLE_ADMINISTRATOR);
    const isSaAdmin = roles.includes(configData.ROLE_SAADMIN);
    const isSales = roles.includes(configData.ROLE_SALES_PEOPLE) || roles.includes(configData.ROLE_SALES_DIRECTOR);
    const agencyDomain = [configData.RSMWW_AGENCY_DOMAIN, configData.RSMWW_AGENCY_DOMAIN1].includes(window.location.host);
    const dashboardHome = <li><a href={"/user/" + localStorage.getItem('uid')}>Dashboard Home</a></li>;
    return (
        // Headed like the Success Stories block under it
        <div className="course-success-box quick-links-block">
            <h2 className="success-title">Quick Links</h2>
            <ul className="quick-links-list">
                {/* Live gives administrators their own list only */}
                {isAdministrator ? (
                    <>
                        {dashboardHome}
                        <li><a href={"/user/" + localStorage.getItem('drupal_uid') + "/edit"}>Manage My Profile</a></li>
                        <li><a href={agencyDomain ? "/my_agents_account" : "/my_scouts_account"}>My Account</a></li>
                        <li><a href="/manage/people">People</a></li>
                    </>
                ) : (
                    <>
                        {isSaAdmin && (
                            <>
                                <li><a href="/saadmin-people">People</a></li>
                                <li><a href="/admin/config/content/profile-approval">Approve Profile Changes</a></li>
                                <li><a href="/admin/reports/agent_athlete_scout">Scout, Agent and Athlete Export</a></li>
                                <li><a href="/resource_library">Resource Library</a></li>
                            </>
                        )}
                        {isSales && dashboardHome}
                    </>
                )}
            </ul>
        </div>
    );
};

export default QuickLinks;
